<template>
    <b-container fluid class="mt--7">
        <b-card title="Default Role for Notifications">
            <b-card-body>
                <b-form>
                    <b-form-select
                        v-model="model_role_id"
                        :options="roles"
                        text-field="name"
                        value-field="id"
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled
                                >-- Select the Default Role
                                --</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                    <b-button variant="link" @click="updateRole"
                        >Update</b-button
                    >
                </b-form>
            </b-card-body>
        </b-card>
    </b-container>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'defaultRole',
    mixins: [popupMixins, permissionsMixins],
    data: () => ({
        model_role_id: null,
        updating: false,
    }),

    computed: {
        defaultRole() {
            const defaultRole = this.$store.getters['company/defaultRole']
            console.log('computed defaultRole', defaultRole)
            return defaultRole
        },

        defaultRoleKey() {
            return this.$store.state.company.settingKeys.defaultRoleKey
        },

        roles() {
            return this.$store.state.roles.items
        },
    },

    watch: {
        defaultRole: {
            handler: function (val) {
                console.log('watch defaultRole', val)
                this.updateModel(val)
            },
            deep: true,
        },
    },

    created() {
        this.$store.dispatch('roles/fetchAll')
    },

    async mounted() {
        await this.$store.dispatch(
            'company/fetchConfiguration',
            this.defaultRoleKey
        )
        this.$nextTick(() => {
            this.updateModel(this.defaultRole)
        })
    },

    methods: {
        updateModel(defaultRole) {
            this.model_role_id = defaultRole
        },
        async updateRole() {
            try {
                this.updating = true
                const text_value = this.model_role_id.toString()
                const bool_value = false

                this.$store.dispatch('company/updateConfiguration', {
                    key: this.defaultRoleKey,
                    text_value,
                    bool_value,
                })
                this.doToast('Success!', 'Settings Updated', 'success')
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },
    },
}
</script>
